<pc-responsive-abstract-card class="success-content-structure" [size]="'summary-card'">
  <div
    class="success-content-header"
    role="button"
    tabindex="0"
    [attr.aria-label]="title() | translate"
    (click)="changeOverviewMode()"
    (keyup.enter)="changeOverviewMode()"
  >
    <span class="body-medium-link">{{ title() | translate }}</span>
    <pc-icon [@rotateChevron]="chevronState()" [icon]="PcButtonIcon.CHEVRON_DOWN_BLUE" [size]="'xsmall'"> </pc-icon>
  </div>
  @if (isSuccessOverviewOpen()) {
    <hr />
  }
  <section [@expandCollapse]="quoteOverviewState()">
    <ng-content></ng-content>
  </section>
</pc-responsive-abstract-card>
